<template>
  <article class="group relative overflow-hidden rounded-2xl bg-navy-950 shadow-card ring-1 ring-navy-900/10">
    <img
      :src="image"
      :alt="title"
      class="h-72 w-full object-cover opacity-70 transition duration-500 group-hover:scale-[1.04] group-hover:opacity-60 sm:h-80"
    />
    <div class="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/55 to-transparent"></div>

    <div class="absolute inset-x-0 bottom-0 p-6">
      <span class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white/15 text-sky-200 backdrop-blur-sm">
        <i :class="[icon, 'text-base']"></i>
      </span>
      <h3 class="mt-4 text-xl font-bold tracking-tight text-white">{{ title }}</h3>
      <p class="mt-2 text-sm leading-6 text-sky-200/90">{{ description }}</p>
    </div>
  </article>
</template>

<script setup>
defineProps({
  icon: String,
  title: String,
  description: String,
  image: String
})
</script>
